import { render, staticRenderFns } from "./ScreensRearrangementDialog.vue?vue&type=template&id=f27d209c&scoped=true&"
import script from "./ScreensRearrangementDialog.vue?vue&type=script&lang=js&"
export * from "./ScreensRearrangementDialog.vue?vue&type=script&lang=js&"
import style0 from "./ScreensRearrangementDialog.vue?vue&type=style&index=0&id=f27d209c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f27d209c",
  null
  
)

export default component.exports